import { ErrorMessage, Field } from "formik";
import React, { useRef, useState } from "react";
import { ReactComponent as CheckoutIcon } from "../../icons/checkoutIcon.svg";
import { ReactComponent as InfoIcon } from "../../icons/infoIcon.svg";
import Tooltip from "../shared/Tooltip";
import { classes } from "../../utils/Classes";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

export const CreditCardBox = (props) => {
  //const { values } = props;
  const ref1 = useRef(null);
  const { maxHeightTrans } = classes;
  const [stripeError, setStripeError] = useState(null);

  return (
    <div>
      <div
        ref={ref1}
        className={`px-4 overflow-hidden ${maxHeightTrans} max-h-[420px] sm:max-h-[320px]"`}
      >
        <div className="my-4 w-full">
          <div className="relative">
            <CardNumberElement
              options={{
                style: {
                  base: {
                    fontSize: "16px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                  invalid: {
                    color: "#9e2146",
                  },
                },
              }}
              className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
              onChange={(event) => {
                if (event.error) {
                  setStripeError(event.error.message);
                } else {
                  setStripeError(null);
                }
              }}
            />
            <div className="absolute top-[50%] transform -translate-y-1/2 right-0 flex items-center justify-center pr-3 pointer-events-none w-8 h-8">
              <CheckoutIcon />
            </div>
          </div>
          {stripeError && (
            <div className="text-red-500 text-xs mt-1">{stripeError}</div>
          )}
        </div>

        <div className="mb-4 flex flex-col sm:flex-row gap-4 w-full">
          <div className="w-full">
            <CardExpiryElement
              options={{
                style: {
                  base: {
                    fontSize: "16px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                  invalid: {
                    color: "#9e2146",
                  },
                },
              }}
              className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
              onChange={(event) => {
                if (event.error) {
                  setStripeError(event.error.message);
                } else {
                  setStripeError(null);
                }
              }}
            />
          </div>

          <div className="w-full">
            <div className="relative">
              <CardCvcElement
                options={{
                  style: {
                    base: {
                      fontSize: "16px",
                      color: "#424770",
                      "::placeholder": {
                        color: "#aab7c4",
                      },
                    },
                    invalid: {
                      color: "#9e2146",
                    },
                  },
                }}
                className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
                onChange={(event) => {
                  if (event.error) {
                    setStripeError(event.error.message);
                  } else {
                    setStripeError(null);
                  }
                }}
              />
              <span className="text-[#707070] stroke-current absolute z-10 right-0 top-[50%] transform -translate-y-1/2 pr-3 cursor-pointer">
                <Tooltip
                  content={
                    <div className="w-36 text-xs text-center py-2 leading-relaxed">
                      3-digit security code usually found on the back of your
                      card. American Express cards have a 4-digit code located
                      on the front.
                    </div>
                  }
                >
                  <InfoIcon fill="none" height="18px" width="18px" />
                </Tooltip>
              </span>
            </div>
          </div>
        </div>

        <div className="mb-4 w-full relative">
          <Field
            id="nameOnCard"
            type="text"
            name="nameOnCard"
            placeholder="Name on Card"
            className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
          />
          <ErrorMessage
            name="nameOnCard"
            component="div"
            className="text-red-500 text-xs mt-1"
          />
        </div>
      </div>
    </div>
  );
};
